export default __webpack_public_path__ + "static/media/vinyl_black.84e765d5.svg";